import React from 'react';
import { Table } from 'antd';

// A reusable dynamic table component with pagination
const DynamicTable = ({ columns, data, onRowClick, pagination, loading }) => {
    return (
        <Table
            loading={loading}
            columns={columns}          // Columns definition passed as prop
            dataSource={data}           // Data passed as prop
            onRow={onRowClick}          // Row click handler passed as prop
            pagination={pagination}     // Pagination configuration passed as prop
            scroll={{ x: 'max-content' }} // Optional horizontal scroll if needed
        />
    );
};

export default DynamicTable;
